import React from "react";
import AlberoStrutturaKpiView from "./AlberoStrutturaKpiView";

export default function AlberoStrutturaKpiController({
                                                         treeData,
                                                         filtroKpi,
                                                         updateFiltroKpi,
                                                         translate,
                                                     }) {

    function onClickItem(item) {
        updateFiltroKpi('pagina', 1);
        updateFiltroKpi('kpiSel', item);
    }

    return (
        <AlberoStrutturaKpiView
            filtroKpi={filtroKpi}
            treeData={treeData}
            translate={translate}
            onClickItem={onClickItem}
        />
    );
}